import {
    GET_GMB_PROFILE_STARTED,
    GET_GMB_PROFILE_SUCCESS,
    GET_GMB_PROFILE_FAILURE,
    CONNECT_GMB_STARTED,
    CONNECT_GMB_SUCCESS,
    CONNECT_GMB_FAILURE,
    SAVE_GMB_TOKENS_STARTED,
    SAVE_GMB_TOKENS_SUCCESS,
    SAVE_GMB_TOKENS_FAILURE,
    SAVE_GMB_TOKENS_IDLE,
    UPDATE_GMB_TOKENS_STARTED,
    UPDATE_GMB_TOKENS_SUCCESS,
    UPDATE_GMB_TOKENS_FAILURE,
    UPDATE_GMB_LOCATION_STARTED,
    UPDATE_GMB_LOCATION_SUCCESS,
    UPDATE_GMB_LOCATION_FAILURE,
    DISCONNECT_GMB_STARTED,
    DISCONNECT_GMB_SUCCESS,
    DISCONNECT_GMB_FAILURE,
    REMOVE_GMB_MESSAGE,
} from '../../constants/gmb/gmb'

const initialState = {
    isConnected: false,
    profile: null,      // { email, name, picture, ... } from GET /api/gmb/profile
    loading: false,     // fetching profile or connecting
    saving: false,      // saving tokens after OAuth callback
    error: null,
    message: null,
}

export default function gmb(state = initialState, action) {
    switch (action.type) {
        case GET_GMB_PROFILE_STARTED:
            return { ...state, loading: true, error: null, message: null }
        case GET_GMB_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                isConnected: action.payload.isConnected ?? true,
                profile: action.payload.profile ?? action.payload,
                error: null,
                message: null,
            }
        case GET_GMB_PROFILE_FAILURE:
            return { ...state, loading: false, isConnected: false, error: action.payload.error }

        case CONNECT_GMB_STARTED:
            return { ...state, loading: true, error: null, message: null }
        case CONNECT_GMB_SUCCESS:
            return { ...state, loading: false }
        case CONNECT_GMB_FAILURE:
            return { ...state, loading: false, error: action.payload.error }

        case SAVE_GMB_TOKENS_STARTED:
            return { ...state, saving: true, error: null, message: null }
        case SAVE_GMB_TOKENS_SUCCESS:
            return {
                ...state,
                saving: false,
                isConnected: true,
                profile: action.payload.profile ?? action.payload,
                error: null,
                message: 'Google account connected successfully!',
            }
        case SAVE_GMB_TOKENS_IDLE:
            return { ...state, saving: false }

        case SAVE_GMB_TOKENS_FAILURE:
            return { ...state, saving: false, error: action.payload.error }

        case UPDATE_GMB_TOKENS_STARTED:
            return { ...state, error: null, message: null }
        case UPDATE_GMB_TOKENS_SUCCESS:
            return { ...state, profile: action.payload.profile ?? state.profile }
        case UPDATE_GMB_TOKENS_FAILURE:
            return { ...state, error: action.payload.error }

        case UPDATE_GMB_LOCATION_STARTED:
            return { ...state, error: null, message: null }
        case UPDATE_GMB_LOCATION_SUCCESS:
            return { ...state, profile: action.payload, error: null, message: null }
        case UPDATE_GMB_LOCATION_FAILURE:
            return { ...state, error: action.payload.error }

        case DISCONNECT_GMB_STARTED:
            return { ...state, loading: true, error: null, message: null }
        case DISCONNECT_GMB_SUCCESS:
            return { ...initialState }
        case DISCONNECT_GMB_FAILURE:
            return { ...state, loading: false, error: action.payload.error }

        case REMOVE_GMB_MESSAGE:
            return { ...state, error: null, message: null }

        default:
            return state
    }
}
